<!-- eslint-disable vue/no-multiple-template-root -->
<template>
  <el-table-column
    v-for="role in visibleRoleColumns"
    :key="role.key"
    :column-key="role.key"
    width="150"
    align="center"
    class-name="permission-column"
  >
    <template #header>
      <button class="role-header-button" @click="openEditRoleDialog(role)">
        {{ role.label }}
      </button>
    </template>
    <template #default="scope">
      <RolePermissionMatrixCell
        :row-kind="scope.row.kind"
        :model-value="scope.row.permissions[role.key]"
        :status="scope.row.permissions[role.key]"
        :hide-button-access="shouldHideChildAccess(scope.row, role.key)"
        :changed="changedCellMap[getCellKey(scope.row.id, role.key)] === true"
        :options="permissionOptions"
        mode="view"
      />
    </template>
  </el-table-column>
</template>

<script setup lang="ts">
  import RolePermissionMatrixCell from '@/pages/master/role-permission/RolePermissionMatrixCell.vue';

  export type PermissionValue = 'full' | 'edit' | 'view' | 'limited' | 'none';
  export type RoleKey = string;

  export type PermissionOption = {
    value: PermissionValue;
    label: string;
  };

  export type RoleColumn = {
    key: RoleKey;
    name: string;
    label: string;
  };

  export type PermissionRow = {
    id: string;
    name: string;
    kind: 'screen' | 'button';
    permissions: Record<RoleKey, PermissionValue>;
    parentId?: string;
    children?: PermissionRow[];
  };

  defineProps<{
    visibleRoleColumns: RoleColumn[];
    permissionOptions: PermissionOption[];
    changedCellMap: Record<string, boolean>;
    getCellKey: (rowId: string, roleKey: RoleKey) => string;
    canEditRoleColumn: (roleKey: RoleKey) => boolean;
    isEditableScreen: (rowId: string) => boolean;
    shouldHideChildAccess: (row: PermissionRow, roleKey: RoleKey) => boolean;
    openEditRoleDialog: (role: RoleColumn) => void;
    updatePermission: (
      row: PermissionRow,
      roleKey: RoleKey,
      value: PermissionValue
    ) => void;
  }>();
</script>
